export const arrow = () => (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 1.93207L6.72281 11.3447" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M11.5 1.93207L6.72281 11.3447" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <line x1="1" y1="-1" x2="10.963" y2="-1" transform="matrix(0.474925 0.880026 0.880026 -0.474925 2 1)" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <line x1="1" y1="-1" x2="10.963" y2="-1" transform="matrix(0.474925 0.880026 0.880026 -0.474925 2 1)" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
);
